import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Initialize tooltips for copy buttons
    this.initializeTooltips()
  }

  initializeTooltips() {
    const tooltipTriggerList = this.element.querySelectorAll('[data-bs-toggle="tooltip"]')
    tooltipTriggerList.forEach(tooltipTriggerEl => {
      new bootstrap.Tooltip(tooltipTriggerEl)
    })
  }

  disconnect() {
    // Clean up tooltips
    const tooltips = this.element.querySelectorAll('[data-bs-toggle="tooltip"]')
    tooltips.forEach(tooltip => {
      const instance = bootstrap.Tooltip.getInstance(tooltip)
      if (instance) {
        instance.dispose()
      }
    })
  }
}